export const TICTAC_COOKIES = {
  LATEST_CLASSNAME: 'LATEST_CLASSNAME',
  LATEST_PROJECT: 'LATEST_PROJECT',
  TEMP_PHOTO_MAPPING: 'TEMP_PHOTO_MAPPING',
};
